import { Button, Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onNextPageClick: () => void;
  onPreviousPageClick: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onNextPageClick,
  onPreviousPageClick,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Card>
      <CardBody className="p-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-default-600">
            Page {currentPage} of {totalPages}
          </div>
          <div className="flex gap-2">
            <Button
              variant="bordered"
              size="sm"
              isDisabled={currentPage <= 1}
              onPress={onPreviousPageClick}
              startContent={<FiChevronLeft className="w-4 h-4" />}
            >
              Previous
            </Button>
            <Button
              variant="bordered"
              size="sm"
              isDisabled={currentPage >= totalPages}
              onPress={onNextPageClick}
              endContent={<FiChevronRight className="w-4 h-4" />}
            >
              Next
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
